<mat-grid-list cols="4" rowHeight='500px'>
    <mat-grid-tile *ngFor='let plan of plans' colspan='1' rowspan='1'>
        <mat-card class="example-card mat-elevation-z8">
            <img mat-card-image [src]="plan.payload.doc.data().imgurl" class="planimg">
            <mat-card-content>
                <h5 class="text-center">{{plan.payload.doc.data().pname | uppercase}}</h5>
                <h6 class="text-center">{{plan.payload.doc.data().category}}</h6>
                <p class="text-center">Rs. <span id="price">{{plan.payload.doc.data().price}}</span>/Month</p>
                </mat-card-content>
            <mat-card-actions class="text-center">
                <button mat-raised-button class="coolbtn" (click)='selectPlan(plan.payload.doc.id)'>SELECT PLAN</button>
            </mat-card-actions>
        </mat-card>
    </mat-grid-tile>
</mat-grid-list>